import { useState } from "react";
import { dateToHumanFormat } from "../../../utils/constants";

function RepayDates({ dates }) {

    const show = 24;
    const [itemsToShow, setItemsToShow] = useState(show);
    const [expanded, setExpanded] = useState(false);

    const showMore = () => {
        setItemsToShow(expanded ? show : dates.length);
        setExpanded(!expanded);
    };

    return (
        <>
        {dates.slice(0, itemsToShow).map((date, index) => (
            <div key={index} className="rounded-lg p-3 bg-gray-50 border border-gray-100 dark:border-gray-500 flex items-center justify-center dark:bg-gray-800">
                <p className="text-xs font-semibold text-gray-600 dark:text-gray-200">{dateToHumanFormat(date)}</p>
            </div>
        ))}

        {dates.length > show && (
            <div className="col-span-full">
                <div className="relative w-[95%] mx-auto flex py-1.5 items-center">
                    <div className="flex-grow border-t border-slate-200" />
                    <button
                        type="button"
                        className="flex-shrink mx-4 text-sm text-gray-400 hover:text-gray-600 transition-colors"
                        onClick={showMore}
                    >
                        {expanded ? "Show less" : "Show more"}
                    </button>
                    <div className="flex-grow border-t border-slate-200" />
                </div>
            </div>
        )}
        </>
    );
}

export default RepayDates;
